import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import { ActionTypes } from "../Constants/ActionTypes";

export const getVideoEditActivityHistory = (dispatch, payload) => {
  const schoolId = getFromLocalStorage("schoolId");
  dispatch({
    type: ActionTypes.ACTIVITY_HISTORY_LOADING,
    payload: true,
  });
  userService
    .getActivityHistory(
      "VIDEO_EDIT",
      schoolId,
      payload.status ? 0 : payload.pageNumber,
      10
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.GET_VIDEO_EDIT_ACTIVITY,
        payload: {
          status: payload.status,
          data: res.data.data,
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_ERROR,
        payload: error,
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    });
};

export const getSharedVideoActivity = (dispatch, payload) => {
  const schoolId = getFromLocalStorage("schoolId");
  dispatch({
    type: ActionTypes.ACTIVITY_HISTORY_LOADING,
    payload: true,
  });
  userService
    .getActivityHistory(
      "VIDEO_SHARED",
      schoolId,
      payload.status ? 0 : payload.pageNumber,
      10
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.GET_VIDEO_SHARED_ACTIVITY,
        payload: {
          status: payload.status,
          data: res.data.data,
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_ERROR,
        payload: error,
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    });
};

export const getAddedMemberActivity = (dispatch, payload) => {
  const schoolId = getFromLocalStorage("schoolId");
  dispatch({
    type: ActionTypes.ACTIVITY_HISTORY_LOADING,
    payload: true,
  });
  userService
    .getActivityHistory(
      "MEMBER_ADDED",
      schoolId,
      payload.status ? 0 : payload.pageNumber,
      10
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.GET_MEMBER_ADDED_ACTIVITY,
        payload: {
          status: payload.status,
          data: res.data.data,
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_ERROR,
        payload: error,
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    });
};

export const getAddedSeasonActivity = (dispatch, payload) => {
  const schoolId = getFromLocalStorage("schoolId");
  dispatch({
    type: ActionTypes.ACTIVITY_HISTORY_LOADING,
    payload: true,
  });
  userService
    .getActivityHistory(
      "SEASON_ADDED",
      schoolId,
      payload.status ? 0 : payload.pageNumber,
      10
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.GET_SEASON_ADDED_ACTIVITY,
        payload: {
          status: payload.status,
          data: res.data.data,
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_ERROR,
        payload: error,
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    });
};

export const getAddedScheduleActivity = (dispatch, payload) => {
  const schoolId = getFromLocalStorage("schoolId");
  dispatch({
    type: ActionTypes.ACTIVITY_HISTORY_LOADING,
    payload: true,
  });
  userService
    .getActivityHistory(
      "SCHEDULE_ADDED",
      schoolId,
      payload.status ? 0 : payload.pageNumber,
      10
    )
    .then((res) => {
      dispatch({
        type: ActionTypes.GET_SCHEDULE_ADDED_ACTIVITY,
        payload: {
          status: payload.status,
          data: res.data.data,
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_ERROR,
        payload: error,
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    });
};

export const getAllActivityHistory = (dispatch, payload) => {
  const schoolId = getFromLocalStorage("schoolId");
  dispatch({
    type: ActionTypes.ACTIVITY_HISTORY_LOADING,
    payload: true,
  });
  userService
    .getActivityHistory(
      "ALL",
      schoolId,
      payload.status ? 0 : payload.pageNumber,
      10
    )
    .then((res) => {
      if (res.status === 200) {
        dispatch({
          type: ActionTypes.GET_ALL_ACTIVITY,
          payload: {
            status: payload.status,
            data: res.data.data,
          },
        });
      } else {
        dispatch({
          type: ActionTypes.ACTIVITY_HISTORY_LOADING,
          payload: false,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_ERROR,
        payload: error,
      });
      dispatch({
        type: ActionTypes.ACTIVITY_HISTORY_LOADING,
        payload: false,
      });
    });
};

export const resetActivityHistoryInitialState = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RESET_ACTIVITY_HISTORY_INITIAL_STATE,
    payload: null,
  });
};
